import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@lumika/ui";

// Tab bar mirrors DealershipScope.tsx so the playground feels native to
// the admin app. Two subroutes: /channels-playground/api and /widget.
const TABS = [
  { to: "api", label: "API" },
  { to: "widget", label: "Widget" },
];

export function ChannelsPlaygroundLayout() {
  return (
    <div className="flex h-full flex-col">
      <header className="flex flex-col gap-4 border-b bg-card px-6 py-5">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-muted-foreground">
            Playground
          </p>
          <h1 className="mt-1 truncate text-2xl font-semibold tracking-tight">
            Channels Playground
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Drive the deployed widget and API channels against this
            environment.
          </p>
        </div>
        <nav className="-mx-6 flex gap-1 overflow-x-auto px-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                cn(
                  "inline-flex min-h-touch shrink-0 items-center whitespace-nowrap rounded-md border border-transparent px-3 py-1.5 text-sm font-medium transition-colors",
                  isActive
                    ? "border-border bg-background text-foreground shadow-sm"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground",
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <div className="min-w-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
